export default __webpack_public_path__ + "static/media/ScanPass.ae495306.svg";